// Client-side category filter for the Weekly Food Offers section.
//
// Pills are <a> elements with href="<category archive>" so they remain
// usable / SEO-friendly without JS. With JS we intercept the click,
// preventDefault, swap the active pill, and toggle .is-hidden on cards
// whose data-categories list doesn't include the active filter slug.

(function () {
    const ACTIVE = 'is-active';
    const HIDDEN = 'is-hidden';

    function init() {
        document.querySelectorAll('.home-offers').forEach(setup);
    }

    function setup(section) {
        const pills = section.querySelectorAll('[data-filter]');
        const grid  = section.querySelector('[data-offers-grid]');
        const empty = section.querySelector('[data-offers-empty]');
        if (!pills.length || !grid) return;

        const cards = Array.from(grid.querySelectorAll('[data-categories]'));

        pills.forEach((pill) => {
            pill.addEventListener('click', (e) => {
                e.preventDefault();
                applyFilter(pill, pills, cards, empty);
            });
        });
    }

    function applyFilter(pill, pills, cards, empty) {
        const filter = pill.dataset.filter;

        // Update active state
        pills.forEach((p) => {
            p.classList.toggle(ACTIVE, p === pill);
            p.setAttribute('aria-selected', p === pill ? 'true' : 'false');
        });

        // Filter cards
        let visible = 0;
        cards.forEach((card) => {
            const cats = (card.dataset.categories || '').trim().split(/\s+/);
            const show = filter === 'all' || cats.includes(filter);
            card.classList.toggle(HIDDEN, !show);
            if (show) visible++;
        });

        // Empty-state
        if (empty) empty.hidden = visible > 0;
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
